module.exports = __webpack_public_path__ + "img/pt-17.72e507ed.jpg";